import React from 'react';
import PropTypes from 'prop-types';
import { viewports } from '@telus-uds/system-constants';
import { BaseView, StyleSheet, createMediaQueryStyles } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
function generateResponsiveStyles(min, max) {
  const viewportsArray = viewports.keys;
  const minIndex = viewportsArray.indexOf(min);
  const maxIndex = viewportsArray.indexOf(max);
  let hiddenViewports = [];
  if (minIndex !== -1) {
    hiddenViewports = viewportsArray.slice(0, minIndex);
  }
  if (maxIndex !== -1) {
    hiddenViewports = hiddenViewports.concat(viewportsArray.slice(maxIndex + 1));
  }
  const styles = {};
  viewportsArray.forEach(viewport => {
    if (hiddenViewports.includes(viewport)) {
      styles[viewport] = {
        display: 'none'
      };
    }
  });
  return createMediaQueryStyles(styles, false);
}
const ResponsiveWithMediaQueryStyleSheet = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    min,
    max,
    inheritedStyles = [],
    children
  } = _ref;
  const {
    ids,
    styles
  } = StyleSheet.create({
    responsive: {
      ...inheritedStyles.reduce((acc, prop) => {
        acc[prop] = 'inherit';
        return acc;
      }, {}),
      ...generateResponsiveStyles(min, max)
    }
  });
  return /*#__PURE__*/_jsx(BaseView, {
    style: styles.responsive,
    dataSet: ids.responsive && {
      media: ids.responsive
    },
    ref: ref,
    children: children
  });
});
ResponsiveWithMediaQueryStyleSheet.displayName = 'Responsive';
ResponsiveWithMediaQueryStyleSheet.propTypes = {
  /**
   * To hide children of `Responsive` if the current viewport is smaller than `min`
   */
  min: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * To hide children of `Responsive` if the current viewport is larger than `max`
   */
  max: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  inheritedStyles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired
};
export default ResponsiveWithMediaQueryStyleSheet;